import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormsTurnsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getForms(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_getTurnFormsList', item, options);
  }
  public getFormInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_getTurnFormDetails', item, options);
  }
  public addNewForm(context, lang, udid, active, turnFormName, centerInternalId, calendarsBound, desksBound, addName, addSurname, addDni, addMail, addTelephone,  addLicensePlate, addPassport, addDocument, addCard, intervalCapacity, intervalDuration, maxReservation, intervalOccupacityAlert, reservationForDay, showEndTime, msessionInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, turnFormName, centerInternalId, calendarsBound, desksBound, addName, addSurname, addDni, addMail, addTelephone,  addLicensePlate, addPassport, addDocument, addCard, intervalCapacity, intervalDuration, maxReservation, intervalOccupacityAlert, reservationForDay, showEndTime, msessionInternalId, allowBefore: 60, allowAfter: 20 };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_saveTurnForm', item, options);
  }
  public updateFormInfo(context, lang, udid, internalId, active, turnFormName, centerInternalId, msessionInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerInternalId, msessionInternalId, turnFormName, active };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/update/basicData', item, options);
  }
  public updateFormUserDataInfo(context, lang, udid, internalId, active, addName, addSurname, addDni, addMail, addTelephone, addPassport, addLicensePlate, addDocument, addCard) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, addName, addSurname, addDni, addMail, addTelephone, addPassport, addLicensePlate, addDocument, addCard };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/update/appointmentCustomerData', item, options);
  }
  public updateFormAllowedTimes(context, lang, udid, internalId, allowAfter, allowBefore) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, allowAfter, allowBefore };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateAllowedTimes', item, options);
  }
  public updateFormTokenLength(context, lang, udid, internalId, appointmentTokenLength) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, appointmentTokenLength };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateAppointmentTokenLength', item, options);
  }
  public updatePrivateFormDaysToShow(context, lang, udid, internalId, daysToShowPrivate) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, daysToShowPrivate };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateDaysToShowPrivate', item, options);
  }
  public updatePublicFormDaysToShow(context, lang, udid, internalId, daysToShow) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, daysToShow };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateDaysToShow', item, options);
  }
  public updateFormAccessListFlags(context, lang, udid, internalId, accessListEnable, checkListUserAccount) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, accessListEnable, checkListUserAccount };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateAccessListFlags', item, options);
  }
  public updateFormStripDataInfo(context, lang, udid, internalId, active, intervalCapacity, intervalDuration, maxReservation, intervalOccupacityAlert, reservationForDay) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, intervalCapacity, intervalDuration, maxReservation, intervalOccupacityAlert, reservationForDay };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/update/appointmentOperative', item, options);
  }
  public updateShowIntervalFormat(context, lang, udid, internalId, showEndTime) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, showEndTime };
    return this.http.put(this.BASE_URL + 'private/v2.0/turnFormMaintenance/showEndTime', item, options);
  }
  public updateFormSchedules(context, lang, udid, internalId, active, calendarsBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, calendarsBound };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_saveTurnForm', item, options);
  }
  public addNewFormSchedule(context, lang, udid, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_saveTurnFormCalendar', item, options);
  }
  public updateFormSchedule(context, lang, udid, internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_saveTurnFormCalendar', item, options);
  }
  public addNewFormAvailabilitySchedule(context, lang, udid, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId: null, relatedEntityInternalId, commentNote, startDate, endDate, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, openService, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/availabilityCalendar/save', item, options);
  }
  public updateFormAvailabilitySchedule(context, lang, udid, internalId, relatedEntityInternalId, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, startDate, endDate, openService, commentNote, timeZone) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId, commentNote, startDate, endDate, mon, tue, wed, thu, fri, sat, sun, openTimeMorning, closeTimeMorning, openTimeAfternoon, closeTimeAfternoon, openService, timeZone };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/availabilityCalendar/save', item, options);
  }
  public linkExistingFormAvailabilitySchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/availabilityCalendar/link', item, options);
  }
  public deleteFormAvailabilitySchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/availabilityCalendar/delete', item, options);
  }
  public getFormAvailabilityScheduleInfo(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/calendar/detail', item, options);
  }
  public updateFormDesks(context, lang, udid, internalId, active, desksBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, desksBound };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/update/desks', item, options);
  }
  public updateFormTurnsGeoLocation(context, lang, udid, internalId, latitude, longitude, distanceInMeters) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, latitude, longitude, distanceInMeters };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/update/turnsGeoLocation', item, options);
  }
  public updateFormTurnsOperative(context, lang, udid, internalId, maxTurnsPerDayByService, showEstimatedTime) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, maxTurnsPerDayByService, showEstimatedTime };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/update/turnsOperative', item, options);
  }
  public updateStatusForm(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateStatusTurnForm', item, options);
  }
  public updateShowOnlineForm(context, lang, udid, internalId, online) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, online };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_updateOnline', item, options);
  }
  public deleteForm(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_deleteTurnForm', item, options);
  }
  public deleteFormSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_deleteTurnFormCalendar', item, options);
  }
  public getFormDesks(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_listTurnDesks', item, options);
  }
  public getFormAccessListKeys(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormAccessMaintenance/ws_getAccessList', item, options);
  }
  public addNewFormAccessValue(context, lang, udid, turnFormInternalId, accessValue) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { turnFormInternalId, accessValue };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormAccessMaintenance/ws_addAccess', item, options);
  }
  public deleteNewFormAccessValue(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormAccessMaintenance/ws_deleteAccess', item, options);
  }
  public getFormScheduleInfo(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/calendar/detail', item, options);
  }
  public getFormSessionContexts(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_listMSessions', item, options);
  }
  public getFormExistingSchedules(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/calendar/list', item, options);
  }
  public linkExistingFormSchedule(context, lang, udid, internalId, relatedEntityInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, relatedEntityInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_linkTurnFormCalendar', item, options);
  }
}
